import { createFileRoute } from "@tanstack/react-router";
import { withMemberGate } from "@/lib/with-member-gate";
import { CommunityPage } from "@/components/community/CommunityPage";

export const Route = createFileRoute("/community")({
  head: () => ({
    meta: [
      { name: "robots", content: "noindex" },
      { title: "Trauma Recovery Community — Recovery Trauma™" },
      {
        name: "description",
        content:
          "A private, trauma-informed peer support community for CPTSD, PTSD, anxiety, and emotional recovery. Share reflections, wins, and support with members on a healing path.",
      },
      { property: "og:title", content: "Trauma Recovery Community — Recovery Trauma™" },
      {
        property: "og:description",
        content:
          "A trauma-informed, peer-support community for people navigating recovery.",
      },
      { property: "og:url", content: "https://recoverytrauma.com/community" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      { rel: "canonical", href: "https://recoverytrauma.com/community" },
    ],
  }),
  component: withMemberGate(CommunityPage, "Community"),
});

